(function () {
  var groups = window._usfColorGroups || [];
  if (!groups.length) return;

  var index = {};
  groups.forEach(function (group) {
    group.forEach(function (item) {
      index[item.id] = group;
    });
  });

  var settings = window._usfGlobalSettings || {};
  var limit = parseInt(settings.product_card_variants_display_limit, 10) || 0;
  var shapeClass = settings.product_card_swatches_style_circle ? 'swatch--circle' : 'swatch--square';
  var linkTitleTemplate = window._usfTitleTxt || '{{title}}';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildSwatch(item) {
    var style = '';
    var unavailableClass = '';

    if (item.image) {
      style = 'background-image: url(' + item.image + ');';
    } else if (item.color) {
      style = 'background-color: ' + item.color + ';';
    } else {
      unavailableClass = ' swatch--unavailable';
    }

    return (
      '<span class="swatch color-group__swatch ' + shapeClass + unavailableClass + '" style="' + escapeHtml(style) + '"></span>' +
      '<span class="visually-hidden">' + escapeHtml(item.name) + '</span>'
    );
  }

  function buildHtml(group, productId) {
    var items = '';

    group.forEach(function (item, position) {
      if (limit > 0 && position >= limit) return;

      var isCurrent = String(item.id) === String(productId);
      var itemClass =
        'color-group__item' +
        (isCurrent ? ' color-group__item--current' : '') +
        (item.soldOut ? ' color-group__item--sold-out' : '');
      var swatch = buildSwatch(item);

      if (isCurrent) {
        items +=
          '<li class="' + itemClass + '">' +
          '<span class="color-group__link" aria-current="true" title="' + escapeHtml(item.name) + '">' + swatch + '</span>' +
          '</li>';
      } else {
        var linkTitle = linkTitleTemplate.replace('{{title}}', item.title);
        items +=
          '<li class="' + itemClass + '">' +
          '<a href="' + escapeHtml(item.url) + '" class="color-group__link" title="' + escapeHtml(linkTitle) + '">' + swatch + '</a>' +
          '</li>';
      }
    });

    if (limit > 0 && group.length > limit) {
      items += '<li class="color-group__more">+' + (group.length - limit) + '</li>';
    }

    return '<div class="color-group color-group--card"><ul class="color-group__list">' + items + '</ul></div>';
  }

  function decorate(card) {
    var productId = card.getAttribute('data-usf-pid');
    if (!productId || card.querySelector('.color-group')) return;

    var group = index[productId];
    if (!group || group.length < 2) return;

    var content = card.querySelector('.product-card__content');
    if (!content) return;

    content.insertAdjacentHTML('beforeend', buildHtml(group, productId));
  }

  var scheduled = false;

  function decorateAll() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      document.querySelectorAll('product-card[data-usf-pid]').forEach(decorate);
    });
  }

  function subscribe(attempt) {
    if (window.usf && window.usf.event && window.usf.event.add) {
      window.usf.event.add('sr_updated', decorateAll);
      return;
    }
    if (attempt < 20) {
      window.setTimeout(function () {
        subscribe(attempt + 1);
      }, 300);
    }
  }

  function init() {
    decorateAll();
    subscribe(0);
    new MutationObserver(decorateAll).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();